import { palette } from "@brexhq/metal-foundation-shared";
import styled from "@emotion/styled";
import React from "react";

import {
  type CopyLibraryItem,
  copyLibraryItemToText,
} from "@brexhq/shared/utils/sanity/blocksToText";

type Props = {
  value: {
    copyLibraryItem: CopyLibraryItem;
    highlight?: "none" | "blue" | null;
  };
};

const Pill = styled.span<{ color: "blue" }>(({ color }) => {
  const colorScheme = () => {
    switch (color) {
      case "blue":
        return {
          backgroundColor: palette.slateBlue[2],
          color: palette.slateBlue[10],
        };
      default:
        return {
          backgroundColor: palette.slateBlue[2],
          color: palette.slateBlue[10],
        };
    }
  };
  return {
    ...colorScheme(),
    padding: "2px 8px",
    borderRadius: "calc(infinity * 1px)",
  };
});

export default function CopyLibraryItem(props: Props) {
  const { copyLibraryItem, highlight } = props.value;

  const text = copyLibraryItemToText(copyLibraryItem);

  if (!text) {
    return null;
  }

  if (highlight && highlight !== "none") {
    return (
      <Pill color={highlight}>
        <strong>{text}</strong>
      </Pill>
    );
  }

  return <>{text}</>;
}
